const selectionItemSchema = {
  title: 'Image',
  addMessage: 'Ajouter une image',
  fieldsets: [
    {
      id: 'default',
      title: 'Image',
      fields: ['image'],
    },
  ],
  properties: {
    image: {
      title: 'Image',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
  },
  required: ['image'],
};

// The sidebar shows the folder field or the image list, after the source.
const schema = ({ data }: { data?: any } = {}) => ({
  title: 'Galerie',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'mode',
        data?.mode === 'selection' ? 'images' : 'folder',
        'aspect',
        'columns',
        'lightbox',
      ],
    },
  ],
  properties: {
    mode: {
      title: 'Source',
      type: 'string',
      choices: [
        ['folder', 'Dossier (toutes les images d’un dossier)'],
        ['selection', 'Sélection manuelle'],
      ],
      default: 'folder',
    },
    folder: {
      title: 'Dossier source',
      type: 'string',
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['Folder', 'Document'],
      description:
        'La galerie montre les images rangées dans ce dossier ou cette page, dans leur ordre. Laissez vide pour les images de cette page.',
    },
    images: {
      title: 'Images',
      type: 'array',
      widget: 'object_list',
      schema: selectionItemSchema,
    },
    aspect: {
      title: 'Format',
      type: 'string',
      choices: [
        ['1:1', 'Carré (1:1)'],
        ['4:5', 'Portrait (4:5)'],
        ['3:2', 'Paysage (3:2)'],
        ['mixed', 'Naturel (varié)'],
      ],
      default: '1:1',
    },
    columns: {
      title: 'Colonnes',
      type: 'number',
      choices: [
        [2, '2'],
        [3, '3'],
        [4, '4'],
      ],
      default: 3,
    },
    lightbox: {
      title: 'Activer la lightbox',
      type: 'boolean',
      default: true,
      description: 'Au clic, l’image s’ouvre en grand dans une modale.',
    },
  },
  required: ['mode'],
});

export default schema;
